interface Props {
  class_name?: string;
}

export function SEPARATOR__horizontal({ class_name }: Props) {
  return <div className={`w-full border-t border-component-item ${class_name}`} />;
}
